// 各种mutation类型

// 用户模块
export const LOGOUT = 'LOGOUT'
export const LOGIN = 'LOGIN'



// WEBPACK FOOTER //
// ./src/store/mutation.types.js